// Works Reducer

const worksReducerDefaultState = [];

export default (state = worksReducerDefaultState, action) => {
  switch (action.type) {
      case 'SET_WORKS':
      return action.works;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/works.js